import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem('numbers_token') || localStorage.getItem('auth_token');
      const companyId = localStorage.getItem('numbers_company_id');

      if (token && companyId) {
        // Si hay token en localStorage, intentar validarlo
        try {
          const response = await api.get('/auth/me');
          if (response.data.success) {
            setUser(response.data.data.user);
            setIsAuthenticated(true);
          } else {
            // Si falla, usar información del token (modo externo)
            setUser({
              id: 'external',
              company: { id: companyId },
              role: { name: 'admin_empresa' }
            });
            setIsAuthenticated(true);
          }
        } catch (error) {
          // Token externo - usar información básica
          setUser({
            id: 'external',
            company: { id: companyId },
            role: { name: 'admin_empresa' }
          });
          setIsAuthenticated(true);
        }
      }
    } catch (error) {
      console.error('Error verificando autenticación:', error);
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      if (response.data.success) {
        const { user, tokens } = response.data.data;
        localStorage.setItem('numbers_token', tokens.accessToken);
        localStorage.setItem('numbers_refresh_token', tokens.refreshToken);
        if (user?.company?.id) {
          localStorage.setItem('numbers_company_id', user.company.id);
        }
        setUser(user);
        setIsAuthenticated(true);
        return { success: true };
      }
      return { success: false, message: 'Credenciales inválidas' };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al iniciar sesión'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('numbers_token');
    localStorage.removeItem('numbers_refresh_token');
    localStorage.removeItem('numbers_company_id');
    localStorage.removeItem('auth_token');
    setUser(null);
    setIsAuthenticated(false);
    window.location.href = '/admin/login';
  };

  const value = {
    isAuthenticated,
    user,
    loading,
    login,
    logout,
    checkAuth
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
